<template>

</template>

<script>
export default {
  name: "PetCard"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PetCard.vue